export function getAppPortalContainer() {
  if (typeof document === "undefined") {
    return undefined
  }

  // `#root` exists before React mounts the app tree, so portals always get a
  // stable parent. Pointing them at `#spark-app` can make the container change
  // between the initial render and later updates, which may surface as
  // `removeChild` errors when overlays unmount.
  return document.getElementById("root") ?? document.body ?? undefined
}
